export const columns = [
  // {
  //   key: 'date',
  //   label: 'Game Date',
  // },
  {
    key: 'inning',
    label: 'Inning',
  },
  // {
  //   key: 'player_name',
  //   label: 'Player Name',
  // },
  // {
  //   key: 'team_name',
  //   label: 'Team Name',
  // },
  // {
  //   key: 'opponent_name',
  //   label: 'Opponent',
  // },
  {
    key: 'run_expectancy_change',
    label: 'RE24',
  },
  {
    key: 'base_state_before',
    label: 'Base State',
  },
  {
    key: 'outs_before',
    label: 'Outs',
  },
  {
    key: 'runs_scored',
    label: 'Runs Scored',
  },
  {
    key: 'play_text',
    label: 'Play Text',
  },
  {
    key: 'game_stats_id',
    label: 'Link',
  },
]